<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <ProductsList
        title="Products"
        title-classname="display-1"
      ></ProductsList>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import ProductsList from '../components/ProductsList.vue'

export default {
  components: {
    ApplicationLayout,
    ProductsList
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('Products/setProducts', null)
    next()
  }
}
</script>
